const dimensions = [
  { k: "Contribution", d: "Verified work delivered per mission" },
  { k: "Consistency", d: "Recognition earned across time" },
  { k: "Collaboration", d: "Cross-team signals & assists" },
  { k: "Verification", d: "Quality-checked contributions" },
  { k: "Momentum", d: "Streak, recovery and daily pulse" },
];

const acts = [
  {
    n: "ACT I",
    t: "Duty",
    d: "Existing activities transformed into Daily Missions.",
  },
  {
    n: "ACT II",
    t: "Contribution",
    d: "Every completed mission creates a Recognition Signal.",
  },
  {
    n: "ACT III",
    t: "Recognition",
    d: "Continuous appreciation. Daily. Weekly. Championship-scale.",
  },
  {
    n: "ACT IV",
    t: "Motivation",
    d: "Recognition → Momentum → Participation → Culture.",
  },
];

export default function Recognition() {
  return (
    <section
      id="recognition"
      data-testid="recognition-section"
      className="relative py-28 lg:py-36 border-b border-white/5 bg-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#f59e0b] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#f59e0b]" /> 06 · Recognition Grand Slam
          </div>
          <h2 className="font-display uppercase font-black text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            The target is no
            <br />
            longer <span className="text-neutral-500">chased.</span>{" "}
            <span className="text-[#f59e0b]">It emerges.</span>
          </h2>
          <p className="mt-6 text-neutral-400 leading-relaxed max-w-2xl">
            A gamified recognition platform powered by the Recognition Score Engine —
            five dimensions, five multipliers, and individual Recognition DNA™ profiles.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {/* 4 Acts */}
          <div className="col-span-12 lg:col-span-7">
            <div className="border border-white/10">
              {acts.map((a, i) => (
                <div
                  key={i}
                  data-testid={`recognition-act-${i}`}
                  className="grid grid-cols-12 border-b border-white/10 last:border-b-0 hover:bg-[#0a0a0a] transition-colors"
                >
                  <div className="col-span-3 md:col-span-2 border-r border-white/10 p-5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#f59e0b] flex items-center">
                    {a.n}
                  </div>
                  <div className="col-span-9 md:col-span-10 p-5">
                    <div className="font-display uppercase font-black text-2xl md:text-3xl tracking-tight">
                      {a.t}
                    </div>
                    <div className="mt-1 text-sm text-neutral-400">{a.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dimensions */}
          <div className="col-span-12 lg:col-span-5">
            <div className="border border-white/10 bg-[#0a0a0a] p-6 h-full">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#f59e0b] mb-6">
                RECOGNITION SCORE · 5 DIMENSIONS
              </div>
              <div className="space-y-4">
                {dimensions.map((d, i) => (
                  <div key={i} data-testid={`recognition-dim-${i}`} className="group">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-display uppercase font-bold text-lg tracking-tight">
                        {d.k}
                      </span>
                      <span className="font-mono text-[10px] text-neutral-600">
                        D · {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <div className="text-xs text-neutral-400">{d.d}</div>
                    <div className="mt-2 h-px bg-white/10 relative overflow-hidden">
                      <div
                        className="absolute inset-y-0 left-0 bg-[#f59e0b] group-hover:w-full transition-all duration-700"
                        style={{ width: `${60 + i * 8}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 border-t border-white/10 pt-6 grid grid-cols-2 gap-4">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-2">
                    Employees See
                  </div>
                  <div className="text-sm text-white">Fun · Energy · Identity</div>
                </div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-2">
                    Managers Receive
                  </div>
                  <div className="text-sm text-white">Intel · Signals · Clarity</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
